import { tWithNamespace } from 'shared/hooks/use-loco-translation'
import {
  CreateLightCourseInterface,
  CreateLightCourseLectureInterface,
} from './light-course-interface'

export const getDefaultLightCourseContent = (): Pick<
  CreateLightCourseInterface,
  'name' | 'description'
> => ({
  name: tWithNamespace('dashboard.light_course.default_name') ?? '',
  description: tWithNamespace('dashboard.light_course.default_description') || null,
})

export const getDefaultLightCourseLectureContent = (): CreateLightCourseLectureInterface => ({
  name: tWithNamespace('dashboard.light_course.default_lecture_title') ?? '',
  body: tWithNamespace('dashboard.light_course.default_lecture_description') || null,
})
